/* LoginRequestDto.ts */

/* Utils */
import {
  toCamelCase,
  toSnakeCase,
} from "src/utils/helper/string-transformation";

/* Interfaces */
import { BaseLoginProps } from "src/shared/interfaces/api/Login";

export class LoginRequestDto {
  public credentials;

  constructor(credentials: BaseLoginProps) {
    this.credentials = credentials;
  }

  static fromObject(
    credentials: BaseLoginProps
  ): LoginRequestDto {
    return new LoginRequestDto(credentials);
  }

  toApi() {
    return toSnakeCase({
      usernameEmail: this.credentials.usernameEmail,
      password: this.credentials.password,
    });
  }

  toObject() {
    return toCamelCase({
      usernameEmail: this.credentials.usernameEmail,
      password: this.credentials.password,
    });
  }

  toApiWithOtp(code: string) {
    return toSnakeCase({
      usernameEmail: this.credentials.usernameEmail,
      password: this.credentials.password,
      code: code,
    });
  }
}
